module.exports = __webpack_public_path__ + "static/media/Store Pick List.b3d3285f.jpg";